export const SET_LOADER_ON = "SET_LOADER_ON";
export const SET_LOADER_OFF = "SET_LOADER_OFF";
export const NEW_ACCESSIBLE_STATE = "NEW_ACCESSIBLE_STATE";

export const SET_LOGGED_IN = "SET_LOGGED_IN";
export const LOGOUT = "LOGOUT";
export const TOGGLE_REMINDERS_STATE = "TOGGLE_REMINDERS_STATE";
